import React from 'react'
import classes from './Form.scss'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import MuiTableCell from '@material-ui/core/TableCell'
import { ResponsiveBullet } from '@nivo/bullet'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import { withTranslate } from 'react-redux-multilingual'

const TableCell = withStyles({
  root: {
    border: '1px solid\n ',
    borderColor: '#EBEBEB'
  }
})(MuiTableCell)

const customColumnStyle = { width: '12%', backgroundColor: '#F0F0F0' }

const Form = props => {
  const { data } = props

  if (!data) return
  const { data: rows } = data
  let sortThresholds = data?.thresholds.threshold.sort((a, b) => {
    return +a.end_value - +b.end_value
  })
  let rangesColor = []
  let ranges = []
  sortThresholds.map(item => {
    rangesColor.push(item.color_code)
    ranges.push(+item.end_value)
    return item.color_code
  })
  const renderRow = (data, index) => {
    const {
      actual_value,
      target_value,
      percent_achievement,
      item: {
        uom: { uom_name },
        item_name,
        effective_date,
        perspective: { perspective_name }
      }
    } = data
    const target_percent = percent_achievement

    const dataBullet = [
      {
        // id: '%เป้าหมาย',
        ranges: ranges,
        measures: [target_percent],
        markers: [100]
      }
    ]

    return (
      <Aux key={index}>
        <TableRow>
          <TableCell rowSpan={3}>{perspective_name}</TableCell>
          <TableCell rowSpan={3}>
            <p>{item_name}</p>
            <p style={{ color: 'blue' }}>{effective_date}</p>
          </TableCell>
          <TableCell rowSpan={3}>{uom_name}</TableCell>
          <TableCell style={{ backgroundColor: '#F0F0F0' }} align='left'>
            {props.translate('targetValue')}
          </TableCell>
          <TableCell style={{ backgroundColor: '#F0F0F0' }} align='left'>
            {props.translate('actualValue')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell align='right'>{target_value}</TableCell>

          <TableCell align='right'>{actual_value}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell align='right'>
            %{props.translate('achievement')} {parseFloat(target_percent).toFixed(2)}
          </TableCell>
          <TableCell style={{ minWidth: '250px' }} align='right'>
            <div style={{ widht: '20px', height: '40px' }}>
              <ResponsiveBullet
                data={dataBullet}
                margin={{ top: 5, right: 10, bottom: 25, left: 10 }}
                spacing={20}
                titleAlign='start'
                titleOffsetX={-55}
                measureSize={0.25}
                markerSize={1}
                animate={true}
                motionStiffness={20}
                motionDamping={12}
                measureColors={'black'}
                markerColors={'white'}
                rangeColors={rangesColor}
              />
            </div>
            {/* <OverallTableProgressChart actualValue={+actual_value} targetValue={+target_value} /> */}
          </TableCell>
        </TableRow>
      </Aux>
    )
  }

  return (
    <div>
      <Table className={classes.table} aria-label='spanning table'>
        <TableHead>
          <TableRow style={{ backgroundColor: '#F0F0F0' }}>
            <TableCell style={customColumnStyle} align='left'>
              {props.translate('perspective')}
            </TableCell>
            <TableCell style={{ backgroundColor: '#F0F0F0', minWidth: '150px' }} align='left'>
              {props.translate('kpi')}
            </TableCell>
            <TableCell style={customColumnStyle} align='left'>
              {props.translate('uom')}
            </TableCell>
            <TableCell style={{ width: '52%' }} align='center' colSpan={3}>
              {props.center.label}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{rows.map((r, index) => renderRow(r, index))}</TableBody>
      </Table>
    </div>
  )
}

export default withTranslate(Form)
